module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/sunCare_72d6f3.png";